// The following is to pass tslint and prettier
declare global {
  interface Window {
    trp?: {
      fai?: {
        user?: {
          isUserLoggedIn?: () => boolean;
          logout?: () => void;
        };
        overlay?: {
          signinregister?: {
            showSignInOverlay?: () => void;
            showRegisterOverlay?: () => void;
          };
        };
      };
    };
  }
}

const ERROR_MESSAGE = 'Required global object is not available';

export function faiLoginStatus() {
  if (window.trp?.fai?.user?.isUserLoggedIn) {
    return window.trp.fai.user.isUserLoggedIn();
  }

  return false;
}

export function faiLogin() {
  if (window.trp?.fai?.overlay?.signinregister?.showSignInOverlay) {
    return window.trp.fai.overlay.signinregister.showSignInOverlay();
  }

  throw new Error(ERROR_MESSAGE);
}

export function faiLogout() {
  if (window.trp?.fai?.user?.logout) {
    return window.trp.fai.user.logout();
  }

  throw new Error(ERROR_MESSAGE);
}

export function faiRegister() {
  if (window.trp?.fai?.overlay?.signinregister?.showRegisterOverlay) {
    return window.trp.fai.overlay.signinregister.showRegisterOverlay();
  }

  throw new Error(ERROR_MESSAGE);
}
